import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface WebMaintenanceSupportProps {
    websiteSupportData: any
}

const WebMaintenanceSupport: FC<WebMaintenanceSupportProps> = ({ websiteSupportData }) => {
    return (
        <div>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-6 sm:p-10 lg:p-20 pt-8 sm:pt-12 lg:pt-16 gap-y-8 sm:gap-y-12 lg:gap-y-16 px-4 sm:px-16 lg:px-36 bg-blackDark mt-12'>
                {websiteSupportData.WebSupportFeatureList.map((reliable: any, index: number) => {
                     let img = getImage(reliable.image ?? "") ?? "";
                    return (
                        <motion.div
                            key={index}
                            className='relative p-[1px] flex group'
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{
                                duration: 0.5,
                                ease: "easeOut",
                                delay: 0.1 + (index * 0.04)
                            }}
                        >
                            <motion.div
                                className='p-4 sm:p-6 lg:p-8 w-full flex flex-col gap-4 justify-center items-center border-b-2 sm:border-b-0 sm:border-r-2 border-[#313131] last:border-b-0 sm:last:border-r-0'
                                whileHover={{
                                    y: -5,
                                    transition: { duration: 0.2 }
                                }}
                            >
                                <motion.div
                                    className={`w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded-full flex items-center justify-center bg-darkGreyPrimary group-hover:bg-${reliable.color}`}
                                    whileHover={{ 
                                        scale: 1.05,
                                        rotate: 5,
                                        transition: { duration: 0.2 }
                                    }}
                                >
                                    {/* <img src={reliable.image} className={`w-[45px]`} alt={reliable.title} /> */}
                                    <DynamicSVG size='w-[45px]'>{img}</DynamicSVG>
                                </motion.div>
                                <motion.div
                                    className='flex flex-col gap-1 text-center'
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    transition={{ duration: 0.2, delay: 0.3 + (index * 0.04) }}
                                >
                                    <span className={`text-lg sm:text-xl font-medium text-${reliable.color} `}>
                                        <b>{reliable.title}</b>
                                    </span>
                                    <span className='text-sm sm:text-base'>{reliable.subtitle}</span>
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default WebMaintenanceSupport
